import 'babel-polyfill';
import LinkUrlParameterProcessor from './main/Link/LinkUrlParameterProcessor';
import NavMain from './main/NavMain/NavMainCampaign';
import Parallax from './main/Parallax/Parallax.js';
import PasswordPrompt from './main/PasswordPrompt/PasswordPrompt';
import SmoothScrollingOnDemand from './main/SmoothScrollingOnDemand/SmoothScrollingOnDemand';
import toggleJsClass from './utility/Dom';

toggleJsClass();

{
    const linkUrlParameterProcessor = new LinkUrlParameterProcessor();

    linkUrlParameterProcessor.init();
}

// nav main
{
    new NavMain();
}

// parallax
{
    const parallaxComponents = document.querySelectorAll( '[data-js="parallax"]' );

    for ( const parallax of parallaxComponents ) {
        new Parallax( parallax );
    }
}

// smooth-scrolling
{
    const smoothScrollingComponents = document.querySelectorAll( '[data-js="smooth-scroll"]' );

    for ( const smoothScrollingComponent of smoothScrollingComponents ) {
        new SmoothScrollingOnDemand( smoothScrollingComponent );
    }
}

// password prompt
{
    new PasswordPrompt();
}
